import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  photosById: {},
};

const photosSlice = createSlice({
  name: 'photos',
  initialState,
  reducers: {
    photoEdited(state, action) {
      const { photosById } = state;
      const { photoId, optimisticUri } = action.payload;

      photosById[photoId] = { optimisticUri };
    },
    photoProcessingCompleted(state, action) {
      const { photosById } = state;
      const { photoId } = action.payload;

      delete photosById[photoId];
    },
  },
})

export const { photoEdited, photoProcessingCompleted } = photosSlice.actions
export default photosSlice.reducer